<template>
  <div>

    <GeographyMasthead />

    <section v-if="ready">
      <assignment-list :assignments="assignments">
        <div class="empty" slot="empty">
          <h2>There are currently no assignments due.</h2>
        </div>
      </assignment-list>
    </section>

  </div>
</template>

<script>

  import AssignmentList from "@/components/AssignmentList"
  import GeographyMasthead from "@/components/GeographyMasthead"

  export default {
    name: 'Assignments',
    routeConfig: {
      name: "assignments", path: "/assignments", meta: { transHeader: true }
    },
    components: { AssignmentList, GeographyMasthead },
    metaInfo: {
      title: "Assignments"
    },
    data () {
      return {
        ready: false,
        assignments: this.$store.filter('userAssignments'),
        // this app does not have infinite scrolling implemented
        // in future, if you get a bug report that says "student did not see given assignment",
        // see if they have exactly 100 assignments in the list and then increase this number.
        // alternatively, implement infinite scrolling
        assignmentsPromise: this.$store.findAll('userAssignments', { limit: 100 })
      }
    },
    created () {
      this.assignmentsPromise.then((assignments) => {
        this.ready = true
        this.assignments = assignments
      })
    }
  }
</script>

<style lang="scss" scoped>

  @import "~globals";

  section {
    @include container;
    margin-top:4rem;
    h2 {
      @include font-size(xlarge, $headline: true);
      margin-bottom:4rem;
    }
  }

  .to-read {
    li {
      flex-basis:calc(33% - #{$gutter / 2});
      &:nth-child(n+4) {
        margin-top:4rem;
      }
    }
    figure {
      margin-bottom:1.25rem;
    }
    figcaption {
      @include position(absolute, 0 0 0 0);
      @include container;
      display:flex; align-items:center; background:rgba($color-black, .75); color:#fff; font-size:3.2rem; line-height:1.3; text-align:center; opacity:0; transition:opacity .3s ease-in-out;
    }
    li:hover figcaption {
      opacity:1;
    }
    .title {
      @include font-size(medium, $headline: true);
      display:flex; justify-content:space-between; flex-wrap:wrap;
      * {
        font-size:inherit; line-height:inherit; margin:.5rem 0
      }
      h2 {
        margin-right:1rem;
      }
      a {
        color:$color-primary; text-decoration:none;
      }
      time {
        color:$color-black;
      }
    }
  }

  .empty {
    height:50vh; display:flex; align-items:center; justify-content:center; border:solid .1rem $color-gray-lighter;
    h2 {
      margin-bottom:0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/routes/Assignments/index.vue